import { FormattedMessage } from 'react-intl';

import {
  Content,
  DynamicLabel, Icon, IconWrapper,
  Label,
  NavigationContainer,
  Pager
} from "@/components/organism/PageNavigation/PageNavigation.styles";
import { gaPush, PAGE_NAVIGATION_ACTIONS, PAGE_NAVIGATION_CATEGORY } from '@/configuration/setup/googleAnalytics';

type PageNavigationProps = {
  onNext?: () => void;
  onPrevious?: () => void;
  previousLabel?: string;
  nextLabel?: string;
};

type NavigationButton = {
  key: string;
  onClick: () => void;
  labelId: string;
  dynamicLabel: string;
  iconClass: string;
  reverse: boolean;
  alignEnd: boolean;
  alignRight: boolean;
  iconMarginRight?: boolean;
  iconMarginLeft?: boolean;
};

const PageNavigation = ({
                          onNext,
                          onPrevious,
                          previousLabel,
                          nextLabel,
                        }: PageNavigationProps) => {
  const handlePreviousClick = () => {
    if (!onPrevious) return;
    gaPush({
      category: PAGE_NAVIGATION_CATEGORY,
      action: PAGE_NAVIGATION_ACTIONS.CLICK_PREVIOUS,
      label: `Prev: ${previousLabel}`,
    });
    onPrevious();
  };

  const handleNextClick = () => {
    if (!onNext) return;
    gaPush({
      category: PAGE_NAVIGATION_CATEGORY,
      action: PAGE_NAVIGATION_ACTIONS.CLICK_NEXT,
      label: `Next: ${nextLabel}`,
    });
    onNext();
  };

  const navigationButtons: NavigationButton[] = [
    onPrevious && {
      key: "previous",
      onClick: handlePreviousClick,
      labelId: "getStartedPage.pageNavigation.previous.label",
      dynamicLabel: previousLabel ?? "",
      iconClass: "rioglyph-arrow-left",
      reverse: true,
      alignEnd: true,
      alignRight: true,
      iconMarginRight: true,
    },
    onNext && {
      key: "next",
      onClick: handleNextClick,
      labelId: "getStartedPage.pageNavigation.next.label",
      dynamicLabel: nextLabel ?? "",
      iconClass: "rioglyph-arrow-right",
      reverse: false,
      alignEnd: false,
      alignRight: false,
      iconMarginLeft: true,
    },
  ].filter(Boolean) as NavigationButton[];

  return (
      <NavigationContainer>
        {navigationButtons.map(
            ({
               key,
               onClick,
               labelId,
               dynamicLabel,
               iconClass,
               reverse,
               alignEnd,
               alignRight,
               iconMarginRight,
               iconMarginLeft,
             }) => (
                <Pager
                    key={key}
                    role="button"
                    tabIndex={0}
                    onClick={onClick}
                    onKeyPress={(e) => e.key === "Enter" && onClick()}
                    reverse={reverse}
                >
                  <Content alignEnd={alignEnd}>
                    <Label>
                      <FormattedMessage id={labelId} />
                    </Label>
                    <DynamicLabel alignRight={alignRight}>
                      <FormattedMessage id={dynamicLabel} />
                    </DynamicLabel>
                  </Content>
                  <IconWrapper>
                    <Icon
                        className={`rioglyph ${iconClass}`}
                        right={iconMarginRight}
                        left={iconMarginLeft}
                    />
                  </IconWrapper>
                </Pager>
            )
        )}
      </NavigationContainer>
  );
};

export default PageNavigation;
